import { createSelector } from 'reselect'
import convertDatetimesToEpochtimes from '../utility/convertDatetimesToEpochtimes'

const getDatetimes = (state, layerName) => {
  return state.timestamp.timestamps[layerName]
}

const getLayerName = (state, layerName) => {
  return layerName
}

const getMinTimestamps = state => {
  const { minTime } = state.service.serviceCardActive
  
  return minTime
}

const getMaxTimestamps = state => {
  const { maxTime } = state.service.serviceCardActive
  
  return maxTime
}

const getSeasonalServiceSelected = state => {
  const { name } = state.service.serviceCardActive

  return name === 'RiverIce' || name === 'RiverIceHistorical'
}

export const makeGetEpochtimes = () => {
  return createSelector([getDatetimes, getMinTimestamps, getMaxTimestamps, getSeasonalServiceSelected], (datetimes, minTime, maxTime, seasonal) => {
    try {
      const minTimestamp = seasonal && minTime ? new Date(minTime).toISOString() : null
      const maxTimestamp = seasonal && maxTime ? new Date(maxTime).toISOString(): null
      const datetimesFiltered = (minTimestamp && maxTimestamp)
            ? datetimes.filter(datetime => datetime >= minTimestamp && datetime <= maxTimestamp)
            : datetimes

      return convertDatetimesToEpochtimes(datetimesFiltered)
    } catch (error) {
      return null
    }
  })
}

// export const makeGetMaxEpochtime = getEpochtimes => {
//   return createSelector([getEpochtimes], epochtimes => {
//     return Math.max(epochtimes)
//   })
// }



// WEBPACK FOOTER //
// ./src/selectors/epochtimesSelector.js